(function($) {
    $(document).on('click touchstart', '.ad-close-button', function(e) {
        $('.ad-sticky-bottom').removeClass('visible');
        });
}) (jQuery);   